const ComplaintDashHeader = () => {
  return (
    <div className="recon-main-header">
      <h2>Complaint Dashboard</h2>
    </div>
  );
};

export default ComplaintDashHeader;
